import isUrlPathMatch from './isUrlPathMatch';
import { hasChildren } from '../../../helpers';
const hasActiveChild = (path, children) => hasChildren(children) && children.props.children[1][0].props.component.items.find(menuItem => isUrlPathMatch(path, menuItem.settings.url));
export default hasActiveChild;
//# sourceMappingURL=has-active-child.js.map